module.exports = __webpack_public_path__ + "static/media/white_img_b.c68b49ec.png";